// import React, { createElement, useContext, useState, useEffect } from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import List from "@mui/material/List";
// import IconButton from "@mui/material/IconButton";
// import LogoutIcon from "@mui/icons-material/Logout";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import HomeTwoToneIcon from "@mui/icons-material/HomeTwoTone";
// import GroupTwoToneIcon from "@mui/icons-material/GroupTwoTone";
// import WorkTwoToneIcon from "@mui/icons-material/WorkTwoTone";
// import Diversity3SharpIcon from "@mui/icons-material/Diversity3Sharp";
// import AddModeratorTwoToneIcon from "@mui/icons-material/AddModeratorTwoTone";
// import KeyboardDoubleArrowRightSharpIcon from "@mui/icons-material/KeyboardDoubleArrowRightSharp";
// import KeyboardDoubleArrowLeftSharpIcon from "@mui/icons-material/KeyboardDoubleArrowLeftSharp";
// import PersonOutlineTwoToneIcon from "@mui/icons-material/PersonOutlineTwoTone";
// import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";
// import { Collapse, Tooltip, Stack } from "@mui/material";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
// import ExitToAppIcon from "@mui/icons-material/ExitToApp";
// import MuiAppBar from "@mui/material/AppBar";
// import { tooltipClasses } from "@mui/material/Tooltip";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import CardActionArea from "@mui/material/CardActionArea";
// import DepartmentManagement from "../DepartmentManagement";
// import UserManagement from "../UserManagement";
// import RoleManagement from "../RoleManagement";
// import PageRightsAccess from "../PageRightAccess";
// import CandidateResumeManagement from "../AddNewCandidate";
// import CandidatePerformance from "../CandidatePerformance";
// import { LoginContext } from "../../../contexts/loginContext";
// import { CapitalizeName } from "../../../utils/capitalizeName";
// import JobDescriptionManagementList from "../JobDescriptionManagementList";
// import OrganizationDashboard from "../OrganizationDashboard";
// import ScheduleInterview from "../ScheduleInterview";
// import ListInterview from "../ListInterview";
// import ViewCandidate from "../ViewCandidate";
// import JobDescription from "../JobDescription";
// import AddNewCandidate from "../AddNewCandidate";
// import UpcomingInterviews from "../UpcomingInterviews";
// import CompletedInterviews from "../CompletedInterviews";
// import CandidatesHiredRejected from "../CandidatesHiredRejected";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { logout } from "../../../Redux/slices/authSlice";
// import createInstance from "../../../api/axiosinstance";

// const drawerWidth = 300;

// const openedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
//   borderTopRightRadius: 30,
//   borderBottomRightRadius: 30,
//   backgroundColor: "#006A71",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
//   borderTopRightRadius: 30,
//   borderBottomRightRadius: 30,
//   backgroundColor: "#006A71",
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   backgroundColor: "#1E1E1E",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));
// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   borderRadius: 10,
//   backgroundColor: "#1E1E1E",
//   marginTop: 15,
//   marginRight: 20,
//   width: `calc(100% - 7%)`,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     width: `calc(100% - ${drawerWidth + 40}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));
// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.common.white,
//     color: "rgba(0, 0, 0, 0.87)",
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }));
// const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
//   ({ theme, open }) => ({
//     flexGrow: 1,
//     padding: theme.spacing(3),
//     transition: theme.transitions.create("margin", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     ...(open && {
//       transition: theme.transitions.create("margin", {
//         easing: theme.transitions.easing.easeOut,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//     }),
//   })
// );
// const OranizationLandingPage = ({ title }) => {
//   const aiDishaApi = createInstance("DISHA");
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();
//   const [menudata, setMenudata] = useState("Dashboard");
//   const [titleText, setTitleText] = useState("Dashboard");
//   const [loading, setLoading] = React.useState(true);
//   const [error, setError] = React.useState(null);
//   // const [organizationData, setOrganizationData] = React.useState(null);
//   const userName = CapitalizeName(user?.name || "");
//   const navigate = useNavigate();

//   const icons = [
//     HomeTwoToneIcon,
//     AddModeratorTwoToneIcon,
//     PersonOutlineTwoToneIcon,
//     Diversity3SharpIcon,
//     GroupTwoToneIcon,
//     WorkTwoToneIcon,
//   ];

//   const handleListItemClick = (item) => {
//     setMenudata(item);
//     setTitleText(item);
//     setShowCreateNewJob(false);
//     setShowCreateNewCandidate(false);
//   };

//   const [open, setOpen] = useState(false);
//   const [showCreateNewJob, setShowCreateNewJob] = useState(false);
//   const [showCreateNewCandidate, setShowCreateNewCandidate] = useState(false);

//   const handleOpenCreateNewJob = () => {
//     setMenudata("");
//     setTitleText("Create New Job");
//     setShowCreateNewJob(true);
//   };

//   const handleOpenCreateNewCandidate = () => {
//     setMenudata("");
//     setTitleText("Add Candidate");
//     setShowCreateNewCandidate(true);
//   };

//   const handleDrawerToggle = () => {
//     setOpen(!open);
//   };

//   const handleLogOut = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//     dispatch(logout());
//     setTimeout(() => navigate("/"), 0);
//   };

//   const organizationName = user?.organization?.organization_name;
//   const organizationid = user?.organizationId;
//   const organizationLogo = user?.organization?.organization_logo_url;

//   const [organizationDetails, setOrganizationDetails] = useState(null);

//   useEffect(() => {
//     const fetchOrganization = async () => {
//      try {
//         setLoading(true);
//         setError(null);
        
//         console.log('Fetching organization data for user:', user);
        
//         // Get organization ID from user data
//         const orgId = user?.organizationId;
//         if (!orgId) {
//           setError('No organization ID found in user data');
//           return;
//         }
        
//         const response = await aiDishaApi.get(`/get_organization_by_id?org_id=${orgId}`);
        
//         console.log('API Response status:', response.status);
        
//         if (response.status === 200 && response.data) {
//           const data = response.data;
//           console.log('Full API Response:', data);
          
//           // Handle both response formats
//           const orgData = data.organization || data; // Check if data is nested under 'organization' key
//           console.log('Organization data received from API:', orgData);
//           console.log('Logo URL from API:', orgData.organization_logo_url);
//           setOrganizationDetails(orgData);
//         } else {
//           console.warn('API call failed, checking user data...');
          
//           const fallbackData = {
//             organization_id: user?.organizationId,
//             organization_name: user?.organizationName,
//             organization_logo_url: user?.organizationLogoUrl,
//             organization_domain: user?.organizationDomain,
//           };
          
//           if (fallbackData.organization_id) {
//             console.log('Using fallback data:', fallbackData);
//             setOrganizationDetails(fallbackData);
//           } else {
//             const errorText = await response.text();
//             console.error('API error response:', errorText);
//             setError(`Failed to fetch organization data: ${response.status}`);
//           }
//         }
//       } catch (error) {
//         console.error('Network error fetching organization data:', error);
//         setError(`Network error: ${error.message}`);
//       } finally {
//         setLoading(false);
//       }
//     };


//     fetchOrganization();
//   }, [organizationid]);

//   const fixLinodeUrl = (url) => {
//     if (!url) return null;
    
//     // Fix the SSL certificate issue by using the correct Linode Object Storage format
//     // From: https://ai-codedisha.s3.in-maa-1.linodeobjects.com/...
//     // To: https://in-maa-1.linodeobjects.com/ai-codedisha/...
//     if (url.includes('ai-codedisha.s3.in-maa-1.linodeobjects.com')) {
//       return url.replace(
//         'ai-codedisha.s3.in-maa-1.linodeobjects.com',
//         'in-maa-1.linodeobjects.com/ai-codedisha'
//       );
//     }
    
//     return url;
//   };

//   const organizationMasterOptions = [
//     "Role Management",
//     "Department Management",
//     // "Page access rights",
//   ];

//   const candidateManagementOptions = [
//     "View Candidate",
//     // "Candidate Performance",
//     "Candidates Hired",
//     "Candidates Rejected",
//   ];

//   return (
//     <Box sx={{ display: "flex", backgroundColor: "#f4f9e9" }}>
//       <AppBar position="fixed" open={open} sx={{ background: "#006A71" }}>
//         <Toolbar>
//           <Box sx={{ flexGrow: 1 }}>
//             <Typography
//               variant="h5"
//               color="white"
//               sx={{ fontSize: "20px", textAlign: "left" }}
//             >
//               {titleText}
//             </Typography>
//           </Box>
//           <Button
//             sx={{
//               display: { xs: "none", sm: "flex" },
//               border: "1px solid #B9B9B9",
//               color: "#B9B9B9",
//               height: "45px",
//               width: "148px",
//               borderRadius: "10px",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "15px",
//             }}
//           >
//             <ExitToAppIcon />
//             Export
//           </Button>
//         </Toolbar>
//       </AppBar>
//       <Drawer variant="permanent" open={open}>
//         <DrawerHeader sx={{ position: "relative" }}>
//           <Box
//             sx={{
//               backgroundColor: "white",
//               width: "100%",
//               height: "100%",
//               padding: "10px",
//               borderRadius: "10px 30px 0px 20px",
//               overflow: "hidden",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               textAlign: "center",
//               gap: "10px",
//             }}
//           >
//             {isAuthenticated && (
//               <>
//                 {organizationDetails?.organization_logo_url && (
//                   <Box
//                     component="img"
//                     src={fixLinodeUrl(organizationDetails?.organization_logo_url)}
//                     alt="Org Logo"
//                     sx={{
//                       width: "100px",
//                       height: "50px",
//                       // borderRadius: "20%",
//                       objectFit: "cover",
//                     }}
//                   />
//                 )}

//                 {organizationDetails?.organization_name && (
//                   <Typography
//                     sx={{
//                       fontSize: "14px",
//                       fontWeight: "bold",
//                       color: "#333",
//                       maxWidth: "160px",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {organizationDetails?.organization_name}
//                   </Typography>
//                 )}

//                 <LightTooltip title={`${user?.name || ""}`} placement="right">
//                   <Typography
//                     sx={{
//                       fontSize: "13px",
//                       fontWeight: "bold",
//                       color: "#1E1E1E",
//                       maxWidth: "160px",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       whiteSpace: "nowrap",
//                       display: open ? "block" : "none",
//                     }}
//                   >
//                     Welcome {userName}
//                   </Typography>
//                 </LightTooltip>
//               </>
//             )}
//           </Box>
//         </DrawerHeader>
//         <DrawerHeader>
//           <IconButton
//             color="white"
//             aria-label="open drawer"
//             onClick={handleDrawerToggle}
//             edge="start"
//             sx={{ color: "white", marginRight: 1, marginLeft: 1 }}
//           >
//             {open ? (
//               <KeyboardDoubleArrowLeftSharpIcon />
//             ) : (
//               <KeyboardDoubleArrowRightSharpIcon />
//             )}
//           </IconButton>
//         </DrawerHeader>

//         <List sx={{ color: "white" }}>
//           {[
//             "Dashboard",
//             "Organization Master",
//             "User Management",
//             "Candidate Management",
//           ].map((text, index) => (
//             <ListItem
//               key={text}
//               disablePadding
//               onClick={() => handleListItemClick(text)}
//             >
//               <ListItemButton>
//                 <ListItemIcon sx={{ color: "white" }}>
//                   <LightTooltip title={text}>
//                     {createElement(icons[index % icons.length])}
//                   </LightTooltip>
//                 </ListItemIcon>
//                 <ListItemText primary={text} />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>

//         <DrawerHeader>
//           <IconButton
//             color="inherit"
//             aria-label="open drawer"
//             onClick={handleDrawerToggle}
//             edge="start"
//             sx={{ color: "white", marginRight: 1 }}
//           >
//             <Stack direction="column" spacing={1}>
//               {open ? (
//                 <KeyboardDoubleArrowLeftSharpIcon />
//               ) : (
//                 <KeyboardDoubleArrowRightSharpIcon />
//               )}
//               {isAuthenticated && (
//                 <div onClick={handleLogOut} title="Logout">
//                   <LogoutIcon />
//                 </div>
//               )}
//             </Stack>
//           </IconButton>
//         </DrawerHeader>
//       </Drawer>
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           height: "100vh",
//           backgroundColor: "white",
//           overflow: "auto",
//         }}
//       >
//         <DrawerHeader />

//         {menudata === "Dashboard" && <OrganizationDashboard />}
//         {menudata === "Organization Master" && (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
//               gap: 4,
//               mt: 8,
//               mx: 7,
//             }}
//           >
//             {organizationMasterOptions.map((option) => (
//               <Card key={option} sx={{ maxWidth: 250,bgcolor: "#006A71", minHeight: 100 }}>
//                 <CardActionArea onClick={() => handleListItemClick(option)}>
//                   <CardContent>
//                     <Typography variant="h6" component="div">
//                       {option}
//                     </Typography>
//                   </CardContent>
//                 </CardActionArea>
//               </Card>
//             ))}
//           </Box>
//         )}
//         {menudata === "Candidate Management" && (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
//               gap: 4,
//               mt: 8,
//               mx: 7,
//             }}
//           >
//             {candidateManagementOptions.map((option) => (
//               <Card key={option} sx={{ maxWidth: 250, bgcolor: "#006A71", minHeight: 100 }}>
//                 <CardActionArea onClick={() => handleListItemClick(option)}>
//                   <CardContent>
//                     <Typography variant="h6" component="div">
//                       {option}
//                     </Typography>
//                   </CardContent>
//                 </CardActionArea>
//               </Card>
//             ))}
//           </Box>
//         )}
//         {menudata === "Department Management" && <DepartmentManagement />}
//         {menudata === "Role Management" && <RoleManagement />}
//         {menudata === "User Management" && <UserManagement />}
//         {menudata === "Page access rights" && <PageRightsAccess />}
//         {menudata === "View Candidate" && (
//           <ViewCandidate onOpenCandidate={handleOpenCreateNewCandidate} />
//         )}
//         {showCreateNewCandidate && <AddNewCandidate />}
//         {menudata === "Candidate Performance" && <CandidatePerformance />}
//         {menudata === "Candidates Hired" && (
//           <CandidatesHiredRejected value="Hired" />
//         )}
//         {menudata === "Candidates Rejected" && (
//           <CandidatesHiredRejected value="Rejected" />
//         )}
//         {menudata === "Schedule Interview" && <ScheduleInterview />}
//         {menudata === "List Interview" && <ListInterview />}
//         {menudata === "Upcoming Interviews" && <UpcomingInterviews />}
//         {menudata === "Completed Interviews" && <CompletedInterviews />}
//         {menudata === "Create New Job" && <JobDescription />}
//         {menudata === "View Existing Jobs" && (
//           <JobDescriptionManagementList
//             onOpenJobDescription={handleOpenCreateNewJob}
//           />
//         )}
//         {showCreateNewJob && <JobDescription />}
//       </Box>
//     </Box>
//   );
// };

// export default OranizationLandingPage;










































// import React, { createElement, useState, useEffect } from "react";
// import { styled } from "@mui/material/styles";
// import {
//   Box,
//   Drawer as MuiDrawer,
//   AppBar as MuiAppBar,
//   Toolbar,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   IconButton,
//   Typography,
//   Button,
//   Card,
//   CardActionArea,
//   CardContent,
//   Stack,
//   Tooltip,
//   Avatar,
//   Menu,
//   MenuItem,
//   Divider,
//   Chip,
// } from "@mui/material";
// import {
//   Menu as MenuIcon,
//   ChevronRight as ChevronRightIcon,
//   ChevronLeft as ChevronLeftIcon,
//   Home as HomeIcon,
//   Settings as SettingsIcon,
//   People as PeopleIcon,
//   Business as BusinessIcon,
//   Logout as LogoutIcon,
//   ExpandMore as ExpandMoreIcon,
//   Fullscreen as FullscreenIcon,
//   ArrowBack as ArrowBackIcon,
// } from "@mui/icons-material";
// import COLORS from "../../Themes/Colours";
// import DarkModeIcon from "@mui/icons-material/DarkMode";
// import LightModeIcon from "@mui/icons-material/LightMode";
// import { useThemeMode } from "../../Themes/ThemeContextTemp";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { logout } from "../../../Redux/slices/authSlice";
// import { CapitalizeName } from "../../../utils/capitalizeName";
// import createInstance from "../../../api/axiosinstance";
// import department from "../../../card icons/department.png";
// import role from "../../../card icons/role.png";
// import hire from "../../../card icons/hire.png";
// import reject from "../../../card icons/reject.png";
// import candidate from "../../../card icons/candidate.png";

// // Components
// import DepartmentManagement from "../DepartmentManagement";
// import UserManagement from "../UserManagement";
// import RoleManagement from "../RoleManagement";
// import PageRightsAccess from "../PageRightAccess";
// import CandidateResumeManagement from "../AddNewCandidate";
// import CandidatePerformance from "../CandidatePerformance";
// import JobDescriptionManagementList from "../JobDescriptionManagementList";
// import OrganizationDashboard from "../OrganizationDashboard";
// import ScheduleInterview from "../ScheduleInterview";
// import ListInterview from "../ListInterview";
// import ViewCandidate from "../ViewCandidate";
// import JobDescription from "../JobDescription";
// import AddNewCandidate from "../AddNewCandidate";
// import UpcomingInterviews from "../UpcomingInterviews";
// import CompletedInterviews from "../CompletedInterviews";
// import CandidatesHiredRejected from "../CandidatesHiredRejected";

// const drawerWidth = 300;

// // ==================== STYLED COMPONENTS ====================
// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const StyledDrawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": {
//       ...openedMixin(theme),
//       background: COLORS.secondary,
//       borderRight: `1px solid ${COLORS.border}`,
//     },
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": {
//       ...closedMixin(theme),
//       background: COLORS.secondary,
//       borderRight: `1px solid ${COLORS.border}`,
//     },
//   }),
// }));

// const StyledAppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   background: COLORS.primary,
//   borderBottom: `1px solid ${COLORS.border}`,
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// // ==================== MAIN COMPONENT ====================
// const OranizationLandingPage = ({ title }) => {
//   const aiDishaApi = createInstance("DISHA");
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // State Management
//   const [menudata, setMenudata] = useState("Dashboard");
//   const [titleText, setTitleText] = useState("Organization Admin Dashboard");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [open, setOpen] = useState(true);
//   const [showCreateNewJob, setShowCreateNewJob] = useState(false);
//   const [showCreateNewCandidate, setShowCreateNewCandidate] = useState(false);
//   const [organizationDetails, setOrganizationDetails] = useState(null);
//   const [profileAnchor, setProfileAnchor] = useState(null);
//   const [selectedOrgMaster, setSelectedOrgMaster] = useState(null);
//   const [showOrgMasterCards, setShowOrgMasterCards] = useState(true);
//   const [showCandidateCards, setShowCandidateCards] = useState(true);
//   const { COLORS, theme, toggleTheme } = useThemeMode();

//   const userName = CapitalizeName(user?.name || "");

//   // Menu Configuration
//   const menuItems = [
//     { label: "Dashboard", icon: HomeIcon, key: "Dashboard" },
//     { label: "Organization Master", icon: SettingsIcon, key: "Organization Master" },
//     { label: "User Management", icon: PeopleIcon, key: "User Management" },
//     { label: "Candidate Management", icon: PeopleIcon, key: "Candidate Management" },
//   ];

//   const organizationMasterOptions = [
//     {
//       title: "Role Management",
//       image:role,
//       key: "Role Management",
//       subtitle: "Manage roles and permissions",
//       badge: "Configuration",
//       tag: "Access",
//     },
//     {
//       title: "Department Management",
//       image:department,
//       key: "Department Management",
//       subtitle: "Manage departments",
//       badge: "Configuration",
//       tag: "Structure",
//     },
//   ];

//   const candidateManagementOptions = [
//     {
//       title: "View Candidate",
//       image:candidate,
//       key: "View Candidate",
//       subtitle: "Browse all candidates",
//       badge: "Candidate",
//       tag: "HR",
//     },
//     {
//       title: "Candidates Hired",
//       image:hire,
//       key: "Candidates Hired",
//       subtitle: "View hired candidates",
//       badge: "Candidate",
//       tag: "Success",
//     },
//     {
//       title: "Candidates Rejected",
//       image:reject,
//       key: "Candidates Rejected",
//       subtitle: "View rejected candidates",
//       badge: "Candidate",
//       tag: "Status",
//     },
//   ];

//   // Fetch Organization Details
//   useEffect(() => {
//     const fetchOrganization = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         console.log("Fetching organization data for user:", user);

//         const orgId = user?.organizationId;
//         if (!orgId) {
//           setError("No organization ID found in user data");
//           return;
//         }

//         const response = await aiDishaApi.get(`/get_organization_by_id?org_id=${orgId}`);

//         console.log("API Response status:", response.status);

//         if (response.status === 200 && response.data) {
//           const data = response.data;
//           console.log("Full API Response:", data);

//           const orgData = data.organization || data;
//           console.log("Organization data received from API:", orgData);
//           console.log("Logo URL from API:", orgData.organization_logo_url);
//           setOrganizationDetails(orgData);
//         } else {
//           console.warn("API call failed, checking user data...");

//           const fallbackData = {
//             organization_id: user?.organizationId,
//             organization_name: user?.organizationName,
//             organization_logo_url: user?.organizationLogoUrl,
//             organization_domain: user?.organizationDomain,
//           };

//           if (fallbackData.organization_id) {
//             console.log("Using fallback data:", fallbackData);
//             setOrganizationDetails(fallbackData);
//           } else {
//             const errorText = await response.text();
//             console.error("API error response:", errorText);
//             setError(`Failed to fetch organization data: ${response.status}`);
//           }
//         }
//       } catch (error) {
//         console.error("Network error fetching organization data:", error);
//         setError(`Network error: ${error.message}`);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOrganization();
//   }, [user?.organizationId]);

//   // Fix Linode URL
//   const fixLinodeUrl = (url) => {
//     if (!url) return null;

//     if (url.includes("ai-codedisha.s3.in-maa-1.linodeobjects.com")) {
//       return url.replace(
//         "ai-codedisha.s3.in-maa-1.linodeobjects.com",
//         "in-maa-1.linodeobjects.com/ai-codedisha"
//       );
//     }

//     return url;
//   };

//   // Event Handlers
//   const handleDrawerToggle = () => {
//     setOpen(!open);
//   };

//   const handleListItemClick = (item) => {
//     setMenudata(item);
//     setTitleText(item);
//     setShowCreateNewJob(false);
//     setShowCreateNewCandidate(false);
//     setSelectedOrgMaster(null);
//     setShowOrgMasterCards(true);
//     setShowCandidateCards(true);
//   };

//   const handleOrgMasterCardClick = (masterKey, masterTitle) => {
//     setSelectedOrgMaster(masterKey);
//     setMenudata(masterKey);
//     setTitleText(masterTitle);
//     setShowOrgMasterCards(false);
//   };

//   const handleBackFromOrgMaster = () => {
//     setSelectedOrgMaster(null);
//     setMenudata("Organization Master");
//     setTitleText("Organization Master");
//     setShowOrgMasterCards(true);
//   };

//   const handleCandidateCardClick = (candidateKey, candidateTitle) => {
//     setMenudata(candidateKey);
//     setTitleText(candidateTitle);
//     setShowCandidateCards(false);
//   };

//   const handleBackFromCandidate = () => {
//     setMenudata("Candidate Management");
//     setTitleText("Candidate Management");
//     setShowCandidateCards(true);
//   };

//   const handleOpenCreateNewJob = () => {
//     setMenudata("Create New Job");
//     setTitleText("Create New Job");
//     setShowCreateNewJob(true);
//   };

//   const handleOpenCreateNewCandidate = () => {
//     setMenudata("Add Candidate");
//     setTitleText("Add Candidate");
//     setShowCreateNewCandidate(true);
//   };

//   const handleProfileMenuOpen = (event) => {
//     setProfileAnchor(event.currentTarget);
//   };

//   const handleProfileMenuClose = () => {
//     setProfileAnchor(null);
//   };

//   const handleLogOut = () => {
//     handleProfileMenuClose();
//     localStorage.clear();
//     sessionStorage.clear();
//     dispatch(logout());
//     setTimeout(() => navigate("/"), 0);
//   };

//   const handleFullscreen = () => {
//     if (
//       document.fullscreenElement ||
//       document.webkitFullscreenElement ||
//       document.msFullscreenElement
//     ) {
//       if (document.exitFullscreen) {
//         document.exitFullscreen();
//       } else if (document.webkitExitFullscreen) {
//         document.webkitExitFullscreen();
//       } else if (document.msExitFullscreen) {
//         document.msExitFullscreen();
//       }
//     } else {
//       const element = document.documentElement;
//       if (element.requestFullscreen) {
//         element.requestFullscreen();
//       } else if (element.webkitRequestFullscreen) {
//         element.webkitRequestFullscreen();
//       } else if (element.msRequestFullscreen) {
//         element.msRequestFullscreen();
//       }
//     }
//   };

//   if (!isAuthenticated) {
//     return null;
//   }

//   return (
//     <Box sx={{ display: "flex", background: COLORS.background, minHeight: "100vh" }}>
//       {/* AppBar */}
//       <StyledAppBar position="fixed" open={open}>
//         <Toolbar sx={{ minHeight: "70px", display: "flex", justifyContent: "space-between" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <IconButton
//               color="inherit"
//               aria-label="toggle drawer"
//               onClick={handleDrawerToggle}
//               edge="start"
//               sx={{ color: COLORS.accent }}
//             >
//               {open ? <ChevronLeftIcon /> : <MenuIcon />}
//             </IconButton>

//             {/* Back Button for Organization Master */}
//             {selectedOrgMaster && (
//               <IconButton
//                 onClick={handleBackFromOrgMaster}
//                 sx={{ color: COLORS.accent, mr: 1 }}
//                 title="Go back"
//               >
//                 <ArrowBackIcon />
//               </IconButton>
//             )}

//             {/* Back Button for Candidate Management */}
//             {menudata === "Candidate Management" && !showCandidateCards && (
//               <IconButton
//                 onClick={handleBackFromCandidate}
//                 sx={{ color: COLORS.accent, mr: 1 }}
//                 title="Go back"
//               >
//                 <ArrowBackIcon />
//               </IconButton>
//             )}

//             <Typography
//               variant="h6"
//               noWrap
//               component="div"
//               sx={{
//                 fontSize: "20px",
//                 fontWeight: 600,
//                 color: COLORS.text,
//                 letterSpacing: "0.5px",
//               }}
//             >
//               {titleText}
//             </Typography>
//           </Box>

//           {/* Right Side Actions */}
//           <Stack direction="row" spacing={2} sx={{ display: "flex", alignItems: "center" }}>
            
//             <Toolbar sx={{ justifyContent: "flex-end" }}>
//                           <IconButton
//                             onClick={toggleTheme}
//                             sx={{
//                               color: COLORS.text,
//                               "&:hover": { background: COLORS.hoverBg },
//                             }}
//                           >
//                             {theme === "light" ? (
//                               <DarkModeIcon />
//                             ) : (
//                               <LightModeIcon />
//                             )}
//                           </IconButton>
//                         </Toolbar>
            
            
            
            
            
            
            
            
//             <Tooltip title="Fullscreen Mode (F11)">
//               <IconButton
//                 onClick={handleFullscreen}
//                 sx={{
//                   color: COLORS.text,
//                   "&:hover": { background: COLORS.hoverBg },
//                 }}
//               >
//                 <FullscreenIcon />
//               </IconButton>
//             </Tooltip>

//             <Button
//               onClick={handleProfileMenuOpen}
//               sx={{
//                 display: { xs: "none", sm: "flex" },
//                 alignItems: "center",
//                 gap: 1,
//                 color: COLORS.text,
//                 textTransform: "none",
//                 fontSize: "14px",
//                 padding: "6px 12px",
//                 borderRadius: "6px",
//                 "&:hover": { background: COLORS.hoverBg },
//               }}
//             >
//               <Avatar
//                 sx={{
//                   width: 32,
//                   height: 32,
//                   background: COLORS.accent,
//                   fontSize: "14px",
//                   fontWeight: 700,
//                 }}
//               >
//                 {userName.charAt(0).toUpperCase()}
//               </Avatar>
//               <Typography sx={{ fontSize: "13px" }}>{userName.split(" ")[0]}</Typography>
//               <ExpandMoreIcon sx={{ fontSize: "18px" }} />
//             </Button>

//             {/* Profile Menu */}
//             <Menu
//               anchorEl={profileAnchor}
//               open={Boolean(profileAnchor)}
//               onClose={handleProfileMenuClose}
//               anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//               transformOrigin={{ vertical: "top", horizontal: "right" }}
//               PaperProps={{
//                 sx: {
//                   background: COLORS.primary,
//                   border: `1px solid ${COLORS.border}`,
//                   borderRadius: "8px",
//                   mt: 1,
//                 },
//               }}
//             >
//               <MenuItem
//                 sx={{
//                   color: COLORS.text,
//                   padding: "12px 20px",
//                   "&:hover": { background: COLORS.hoverBg },
//                 }}
//               >
//                 <Avatar
//                   sx={{
//                     width: 28,
//                     height: 28,
//                     background: COLORS.accent,
//                     mr: 1.5,
//                     fontSize: "12px",
//                   }}
//                 >
//                   {userName.charAt(0).toUpperCase()}
//                 </Avatar>
//                 {userName}
//               </MenuItem>

//               <MenuItem
//                 sx={{
//                   color: COLORS.textSecondary,
//                   fontSize: "12px",
//                   padding: "4px 20px",
//                   "&:hover": { background: "transparent" },
//                 }}
//               >
//                 Organization Admin
//               </MenuItem>

//               <Divider sx={{ borderColor: COLORS.border, my: 1 }} />

//               <MenuItem
//                 onClick={handleLogOut}
//                 sx={{
//                   color: COLORS.accent,
//                   padding: "12px 20px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                   "&:hover": { background: COLORS.hoverBg },
//                 }}
//               >
//                 <LogoutIcon sx={{ fontSize: "18px" }} />
//                 Logout
//               </MenuItem>
//             </Menu>
//           </Stack>
//         </Toolbar>
//       </StyledAppBar>

//       {/* Drawer */}
//       <StyledDrawer variant="permanent" open={open}>
//         <DrawerHeader sx={{ minHeight: "70px", 
//                             borderBottom: `1px solid ${COLORS.border}`,
//                             display: "flex",
//                             flexDirection: "column", // 🔥 IMPORTANT
//                             alignItems: "stretch",
//                             padding: 0, }}>
//           {open && isAuthenticated && (
          
//           <>
//           {/* Organization Logo and Name Section */}
//           <Box
//             sx={{
//               backgroundColor: "white",
//               padding: "15px",
//               borderRadius: "8px",
//               margin: "10px",
//               textAlign: "center",
//               gap: "10px",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               borderBottom: `1px solid ${COLORS.border}`,
//             }}
//           >
//             {organizationDetails?.organization_logo_url && (
//               <Box
//                 component="img"
//                 src={fixLinodeUrl(organizationDetails?.organization_logo_url)}
//                 alt="Org Logo"
//                 sx={{
//                   width: "200px",
//                   height: "50px",
//                   objectFit: "cover",
//                 }}
//               />
//             )}

//             {organizationDetails?.organization_name && (
//               <Typography
//                 sx={{
//                   fontSize: "14px",
//                   fontWeight: "bold",
//                   color: "#333",
//                   maxWidth: "200px",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 {organizationDetails?.organization_name}
//               </Typography>
//             )}

//             <Tooltip title={`${user?.name || ""}`} placement="right">
//               <Typography
//                 sx={{
//                   fontSize: "13px",
//                   fontWeight: "bold",
//                   color: "#1E1E1E",
//                   maxWidth: "160px",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 Welcome {userName}
//               </Typography>
//             </Tooltip>
//           </Box>

//              {/* #navigation Title */}
//             <Box sx={{ pr: 2, width: "100%" }}>
//               <Typography
//                 sx={{
//                   fontSize: "11px",
//                   fontWeight: 700,
//                   color: COLORS.accent,
//                   textTransform: "uppercase",
//                   letterSpacing: "1.5px",
//                   mb: 1,
//                 }}
//               >
//                 Navigation
//               </Typography>
//             </Box>

//             </>
//           )}
//         </DrawerHeader>

//         {/* Navigation List */}
//         <List sx={{ color: COLORS.text, flex: 1 }}>
//           {menuItems.map((item) => (
//             <ListItem key={item.key} disablePadding>
//               <ListItemButton
//                 onClick={() => handleListItemClick(item.key)}
//                 sx={{
//                   minHeight: 48,
//                   justifyContent: open ? "initial" : "center",
//                   px: 2.5,
//                   "&:hover": {
//                     background: COLORS.hoverBg,
//                     color: COLORS.accent,
//                   },
//                   color: menudata === item.key && !selectedOrgMaster ? COLORS.accent : COLORS.text,
//                 }}
//               >
//                 <ListItemIcon
//                   sx={{
//                     minWidth: 0,
//                     mr: open ? 3 : "auto",
//                     justifyContent: "center",
//                     color: "inherit",
//                   }}
//                 >
//                   <item.icon sx={{ fontSize: "22px" }} />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={item.label}
//                   sx={{
//                     opacity: open ? 1 : 0,
//                     fontSize: "14px",
//                     "& .MuiTypography-root": {
//                       fontSize: "14px",
//                       fontWeight: menudata === item.key && !selectedOrgMaster ? 600 : 500,
//                     },
//                   }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>

//         {/* Bottom Divider */}
//         <Divider sx={{ borderColor: COLORS.border }} />

//         {/* Bottom Actions */}
//         {open && (
//           <Box
//             sx={{
//               p: 2,
//               display: "flex",
//               flexDirection: "column",
//               gap: 1,
//             }}
//           >
//             <Button
//               onClick={handleLogOut}
//               fullWidth
//               sx={{
//                 color: COLORS.accent,
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 justifyContent: "flex-start",
//                 textTransform: "none",
//                 fontSize: "14px",
//                 padding: "10px 12px",
//                 borderRadius: "6px",
//                 border: `1px solid ${COLORS.border}`,
//                 "&:hover": {
//                   background: COLORS.hoverBg,
//                   borderColor: COLORS.accent,
//                 },
//               }}
//             >
//               <LogoutIcon sx={{ fontSize: "18px" }} />
//               Logout
//             </Button>
//           </Box>
//         )}
//       </StyledDrawer>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           minHeight: "100vh",
//           background: COLORS.background,
//           overflow: "auto",
//           // marginTop: "70px",
//         }}
//       >
//         {/* Dashboard */}
//         {menudata === "Dashboard" && <OrganizationDashboard />}

//         {/* Organization Master Cards Grid */}
//         {menudata === "Organization Master" && showOrgMasterCards && (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
//               gap: 3,
//               mt: 2,
//             }}
//           >
//             {organizationMasterOptions.map((option) => (
//               <Card
//                 key={option.key}
//                 onClick={() => handleOrgMasterCardClick(option.key, option.title)}
//                 sx={{
//                   minWidth: { xs: 260, sm: 300 },
//                   borderRadius: "10px",
//                   border: "1px solid #e5e7eb",
//                   boxShadow: "0 10px 20px rgba(0,0,0,0.08)",
//                   cursor: "pointer",
//                   transition: "all 0.25s ease",
//                   "&:hover": {
//                     transform: "translateY(-4px)",
//                     boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
//                   },
//                 }}
//               >
//                 {/* #image content */}
//                  <Box p={1.5}>
//                     <Box
//                       sx={{
//                         borderRadius: "8px",
//                         bgcolor: "#f5f5f5",
//                         overflow: "hidden",
//                         height: 180,
//                         display: "flex",
//                         alignItems: "center",
//                        justifyContent: "center",
//                       }}
//                     >
//                       <Box
//                         component="img"
//                         src={option.image}
//                         alt={title}
//                         sx={{
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "contain",
//                         }}
//                      />
//                     </Box>
//                   </Box>


//                 <CardContent>
//                   {/* Badges */}
//                   <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
//                     {option.badge && (
//                       <Chip
//                         label={option.badge}
//                         size="small"
//                         sx={{
//                           bgcolor: "#e11d48",
//                           color: "#fff",
//                           fontWeight: 600,
//                           fontSize: "12px",
//                         }}
//                       />
//                     )}

//                     {option.tag && (
//                       <Chip
//                         label={option.tag}
//                         size="small"
//                         sx={{
//                           bgcolor: "rgba(0,0,0,0.06)",
//                           color: "#444",
//                           fontSize: "12px",
//                         }}
//                       />
//                     )}
//                   </Box>

//                   {/* Title */}
//                   <Typography
//                     sx={{
//                       fontSize: "16px",
//                       fontWeight: 600,
//                       color: "#111827",
//                       mb: 1,
//                     }}
//                   >
//                     {option.title}
//                   </Typography>

//                   {/* Subtitle */}
//                   <Typography
//                     sx={{
//                       fontSize: "13px",
//                       color: "#374151",
//                       lineHeight: 1.4,
//                     }}
//                   >
//                     {option.subtitle}
//                   </Typography>
//                 </CardContent>
//               </Card>
//             ))}
//           </Box>
//         )}

//         {/* Candidate Management Cards Grid */}
//         {menudata === "Candidate Management" && showCandidateCards && (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
//               gap: 3,
//               mt: 2,
//             }}
//           >
//             {candidateManagementOptions.map((option) => (
//               <Card
//                 key={option.key}
//                 onClick={() => handleCandidateCardClick(option.key, option.title)}
//                 sx={{
//                   minWidth: { xs: 260, sm: 300 },
//                   borderRadius: "10px",
//                   border: "1px solid #e5e7eb",
//                   boxShadow: "0 10px 20px rgba(0,0,0,0.08)",
//                   cursor: "pointer",
//                   transition: "all 0.25s ease",
//                   "&:hover": {
//                     transform: "translateY(-4px)",
//                     boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
//                   },
//                 }}
//               >
//                 {/* #image content */}
//                  <Box p={1.5}>
//                     <Box
//                       sx={{
//                         borderRadius: "8px",
//                         bgcolor: "#f5f5f5",
//                         overflow: "hidden",
//                         height: 180,
//                         display: "flex",
//                         alignItems: "center",
//                        justifyContent: "center",
//                       }}
//                     >
//                       <Box
//                         component="img"
//                         src={option.image}
//                         alt={title}
//                         sx={{
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "contain",
//                         }}
//                      />
//                     </Box>
//                   </Box>


//                 <CardContent>
//                   {/* Badges */}
//                   <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
//                     {option.badge && (
//                       <Chip
//                         label={option.badge}
//                         size="small"
//                         sx={{
//                           bgcolor: "#e11d48",
//                           color: "#fff",
//                           fontWeight: 600,
//                           fontSize: "12px",
//                         }}
//                       />
//                     )}

//                     {option.tag && (
//                       <Chip
//                         label={option.tag}
//                         size="small"
//                         sx={{
//                           bgcolor: "rgba(0,0,0,0.06)",
//                           color: "#444",
//                           fontSize: "12px",
//                         }}
//                       />
//                     )}
//                   </Box>

//                   {/* Title */}
//                   <Typography
//                     sx={{
//                       fontSize: "16px",
//                       fontWeight: 600,
//                       color: "#111827",
//                       mb: 1,
//                     }}
//                   >
//                     {option.title}
//                   </Typography>

//                   {/* Subtitle */}
//                   <Typography
//                     sx={{
//                       fontSize: "13px",
//                       color: "#374151",
//                       lineHeight: 1.4,
//                     }}
//                   >
//                     {option.subtitle}
//                   </Typography>
//                 </CardContent>
//               </Card>
//             ))}
//           </Box>
//         )}

//         {/* Organization Master Sub-pages */}
//         {selectedOrgMaster === "Department Management" && <DepartmentManagement />}
//         {selectedOrgMaster === "Role Management" && <RoleManagement />}

//         {/* Candidate Management Sub-pages */}
//         {menudata === "View Candidate" && (
//           <ViewCandidate onOpenCandidate={handleOpenCreateNewCandidate} />
//         )}
//         {menudata === "Candidates Hired" && (
//           <CandidatesHiredRejected value="Hired" />
//         )}
//         {menudata === "Candidates Rejected" && (
//           <CandidatesHiredRejected value="Rejected" />
//         )}

//         {/* Other Pages */}
//         {menudata === "User Management" && <UserManagement />}
//         {menudata === "Page access rights" && <PageRightsAccess />}
//         {menudata === "Create New Job" && <JobDescription />}
//         {menudata === "View Existing Jobs" && (
//           <JobDescriptionManagementList onOpenJobDescription={handleOpenCreateNewJob} />
//         )}
//         {menudata === "Schedule Interview" && <ScheduleInterview />}
//         {menudata === "List Interview" && <ListInterview />}
//         {menudata === "Upcoming Interviews" && <UpcomingInterviews />}
//         {menudata === "Completed Interviews" && <CompletedInterviews />}
//         {menudata === "Candidate Performance" && <CandidatePerformance />}

//         {/* Modal Components */}
//         {showCreateNewCandidate && <AddNewCandidate />}
//         {showCreateNewJob && <JobDescription />}
//       </Box>
//     </Box>
//   );
// };

// export default OranizationLandingPage;
















































































import React, { createElement, useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Drawer as MuiDrawer,
  AppBar as MuiAppBar,
  Toolbar,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Chip,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronRight as ChevronRightIcon,
  ChevronLeft as ChevronLeftIcon,
  Home as HomeIcon,
  Settings as SettingsIcon,
  People as PeopleIcon,
  Business as BusinessIcon,
  Logout as LogoutIcon,
  ExpandMore as ExpandMoreIcon,
  Fullscreen as FullscreenIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { useThemeMode } from "../../Themes/ThemeContextTemp";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../Redux/slices/authSlice";
import { CapitalizeName } from "../../../utils/capitalizeName";
import createInstance from "../../../api/axiosinstance";
import department from "../../../card icons/department.png";
import role from "../../../card icons/role.png";
import hire from "../../../card icons/hire.png";
import reject from "../../../card icons/reject.png";
import candidate from "../../../card icons/candidate.png";

// Components
import DepartmentManagement from "../DepartmentManagement";
import UserManagement from "../UserManagement";
import RoleManagement from "../RoleManagement";
import PageRightsAccess from "../PageRightAccess";
import CandidateResumeManagement from "../AddNewCandidate";
import CandidatePerformance from "../CandidatePerformance";
import JobDescriptionManagementList from "../JobDescriptionManagementList";
import OrganizationDashboard from "../OrganizationDashboard";
import ScheduleInterview from "../ScheduleInterview";
import ListInterview from "../ListInterview";
import ViewCandidate from "../ViewCandidate";
import JobDescription from "../JobDescription";
import AddNewCandidate from "../AddNewCandidate";
import UpcomingInterviews from "../UpcomingInterviews";
import CompletedInterviews from "../CompletedInterviews";
import CandidatesHiredRejected from "../CandidatesHiredRejected";

const drawerWidth = 300;

// ==================== STYLED COMPONENTS ====================
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

// Updated StyledDrawer to use customColors prop
const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "customColors",
})(({ theme, open, customColors = {} }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      background: customColors.secondary || "#fff",
      borderRight: `1px solid ${customColors.border || "#e0e0e0"}`,
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      background: customColors.secondary || "#fff",
      borderRight: `1px solid ${customColors.border || "#e0e0e0"}`,
    },
  }),
}));

// Updated StyledAppBar to use customColors prop
const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "customColors",
})(({ theme, open, customColors = {} }) => ({
  background: customColors.primary || "#fff",
  borderBottom: `1px solid ${customColors.border || "#e0e0e0"}`,
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

// ==================== MAIN COMPONENT ====================
const OranizationLandingPage = ({ title }) => {
  const aiDishaApi = createInstance("DISHA");
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { COLORS, theme, toggleTheme } = useThemeMode();

  // State Management
  const [menudata, setMenudata] = useState("Dashboard");
  const [titleText, setTitleText] = useState("Organization Admin Dashboard");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(true);
  const [showCreateNewJob, setShowCreateNewJob] = useState(false);
  const [showCreateNewCandidate, setShowCreateNewCandidate] = useState(false);
  const [organizationDetails, setOrganizationDetails] = useState(null);
  const [profileAnchor, setProfileAnchor] = useState(null);
  const [selectedOrgMaster, setSelectedOrgMaster] = useState(null);
  const [showOrgMasterCards, setShowOrgMasterCards] = useState(true);
  const [showCandidateCards, setShowCandidateCards] = useState(true);

  const userName = CapitalizeName(user?.name || "");

  // Menu Configuration
  const menuItems = [
    { label: "Dashboard", icon: HomeIcon, key: "Dashboard" },
    { label: "Organization Master", icon: SettingsIcon, key: "Organization Master" },
    { label: "User Management", icon: PeopleIcon, key: "User Management" },
    { label: "Candidate Management", icon: PeopleIcon, key: "Candidate Management" },
  ];

  const organizationMasterOptions = [
    {
      title: "Role Management",
      image: role,
      key: "Role Management",
      subtitle: "Manage roles and permissions",
      badge: "Configuration",
      tag: "Access",
    },
    {
      title: "Department Management",
      image: department,
      key: "Department Management",
      subtitle: "Manage departments",
      badge: "Configuration",
      tag: "Structure",
    },
  ];

  const candidateManagementOptions = [
    {
      title: "View Candidate",
      image: candidate,
      key: "View Candidate",
      subtitle: "Browse all candidates",
      badge: "Candidate",
      tag: "HR",
    },
    {
      title: "Candidates Hired",
      image: hire,
      key: "Candidates Hired",
      subtitle: "View hired candidates",
      badge: "Candidate",
      tag: "Success",
    },
    {
      title: "Candidates Rejected",
      image: reject,
      key: "Candidates Rejected",
      subtitle: "View rejected candidates",
      badge: "Candidate",
      tag: "Status",
    },
  ];

  // Fetch Organization Details
  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        setLoading(true);
        setError(null);

        console.log("Fetching organization data for user:", user);

        const orgId = user?.organizationId;
        if (!orgId) {
          setError("No organization ID found in user data");
          return;
        }

        const response = await aiDishaApi.get(`/get_organization_by_id?org_id=${orgId}`);

        console.log("API Response status:", response.status);

        if (response.status === 200 && response.data) {
          const data = response.data;
          console.log("Full API Response:", data);

          const orgData = data.organization || data;
          console.log("Organization data received from API:", orgData);
          console.log("Logo URL from API:", orgData.organization_logo_url);
          setOrganizationDetails(orgData);
        } else {
          console.warn("API call failed, checking user data...");

          const fallbackData = {
            organization_id: user?.organizationId,
            organization_name: user?.organizationName,
            organization_logo_url: user?.organizationLogoUrl,
            organization_domain: user?.organizationDomain,
          };

          if (fallbackData.organization_id) {
            console.log("Using fallback data:", fallbackData);
            setOrganizationDetails(fallbackData);
          } else {
            const errorText = await response.text();
            console.error("API error response:", errorText);
            setError(`Failed to fetch organization data: ${response.status}`);
          }
        }
      } catch (error) {
        console.error("Network error fetching organization data:", error);
        setError(`Network error: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganization();
  }, [user?.organizationId]);

  // Fix Linode URL
  const fixLinodeUrl = (url) => {
    if (!url) return null;

    if (url.includes("ai-codedisha.s3.in-maa-1.linodeobjects.com")) {
      return url.replace(
        "ai-codedisha.s3.in-maa-1.linodeobjects.com",
        "in-maa-1.linodeobjects.com/ai-codedisha"
      );
    }

    return url;
  };

  // Event Handlers
  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleListItemClick = (item) => {
    setMenudata(item);
    setTitleText(item);
    setShowCreateNewJob(false);
    setShowCreateNewCandidate(false);
    setSelectedOrgMaster(null);
    setShowOrgMasterCards(true);
    setShowCandidateCards(true);
  };

  const handleOrgMasterCardClick = (masterKey, masterTitle) => {
    setSelectedOrgMaster(masterKey);
    setMenudata(masterKey);
    setTitleText(masterTitle);
    setShowOrgMasterCards(false);
  };

  const handleBackFromOrgMaster = () => {
    setSelectedOrgMaster(null);
    setMenudata("Organization Master");
    setTitleText("Organization Master");
    setShowOrgMasterCards(true);
  };

  const handleCandidateCardClick = (candidateKey, candidateTitle) => {
    setMenudata(candidateKey);
    setTitleText(candidateTitle);
    setShowCandidateCards(false);
  };

  const handleBackFromCandidate = () => {
    setMenudata("Candidate Management");
    setTitleText("Candidate Management");
    setShowCandidateCards(true);
  };

  const handleOpenCreateNewJob = () => {
    setMenudata("Create New Job");
    setTitleText("Create New Job");
    setShowCreateNewJob(true);
  };

  const handleOpenCreateNewCandidate = () => {
    setMenudata("Add Candidate");
    setTitleText("Add Candidate");
    setShowCreateNewCandidate(true);
  };

  const handleProfileMenuOpen = (event) => {
    setProfileAnchor(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileAnchor(null);
  };

  const handleLogOut = () => {
    handleProfileMenuClose();
    localStorage.clear();
    sessionStorage.clear();
    dispatch(logout());
    setTimeout(() => navigate("/"), 0);
  };

  const handleFullscreen = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", background: COLORS.background, minHeight: "100vh" }}>
      {/* AppBar */}
      <StyledAppBar position="fixed" open={open} customColors={COLORS}>
        <Toolbar sx={{ minHeight: "80px !important", display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton
              color="inherit"
              aria-label="toggle drawer"
              onClick={handleDrawerToggle}
              edge="start"
              sx={{ color: COLORS.accent }}
            >
              {open ? <ChevronLeftIcon /> : <MenuIcon />}
            </IconButton>

            {/* Back Button for Organization Master */}
            {selectedOrgMaster && (
              <IconButton
                onClick={handleBackFromOrgMaster}
                sx={{ color: COLORS.accent, mr: 1 }}
                title="Go back"
              >
                <ArrowBackIcon />
              </IconButton>
            )}

            {/* Back Button for Candidate Management */}
            {menudata === "Candidate Management" && !showCandidateCards && (
              <IconButton
                onClick={handleBackFromCandidate}
                sx={{ color: COLORS.accent, mr: 1 }}
                title="Go back"
              >
                <ArrowBackIcon />
              </IconButton>
            )}

            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                color: COLORS.text,
                letterSpacing: "0.5px",
              }}
            >
              {titleText}
            </Typography>
          </Box>

          {/* Right Side Actions */}
          <Stack direction="row" spacing={2} sx={{ display: "flex", alignItems: "center" }}>
            <Toolbar sx={{ justifyContent: "flex-end" }}>
              <IconButton
                onClick={toggleTheme}
                sx={{
                  color: COLORS.text,
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                {theme === "light" ? <DarkModeIcon /> : <LightModeIcon />}
              </IconButton>
            </Toolbar>

            <Tooltip title="Fullscreen Mode (F11)">
              <IconButton
                onClick={handleFullscreen}
                sx={{
                  color: COLORS.text,
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                <FullscreenIcon />
              </IconButton>
            </Tooltip>

            <Button
              onClick={handleProfileMenuOpen}
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                gap: 1,
                color: COLORS.text,
                textTransform: "none",
                fontSize: "14px",
                padding: "6px 12px",
                borderRadius: "6px",
                "&:hover": { background: COLORS.hoverBg },
              }}
            >
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  background: COLORS.accent,
                  fontSize: "14px",
                  fontWeight: 700,
                }}
              >
                {userName.charAt(0).toUpperCase()}
              </Avatar>
              <Typography sx={{ fontSize: "13px" }}>{userName.split(" ")[0]}</Typography>
              <ExpandMoreIcon sx={{ fontSize: "18px" }} />
            </Button>

            {/* Profile Menu */}
            <Menu
              anchorEl={profileAnchor}
              open={Boolean(profileAnchor)}
              onClose={handleProfileMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  background: COLORS.primary,
                  border: `1px solid ${COLORS.border}`,
                  borderRadius: "8px",
                  mt: 1,
                },
              }}
            >
              <MenuItem
                sx={{
                  color: COLORS.text,
                  padding: "12px 20px",
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                <Avatar
                  sx={{
                    width: 28,
                    height: 28,
                    background: COLORS.accent,
                    mr: 1.5,
                    fontSize: "12px",
                  }}
                >
                  {userName.charAt(0).toUpperCase()}
                </Avatar>
                {userName}
              </MenuItem>

              <MenuItem
                sx={{
                  color: COLORS.textSecondary,
                  fontSize: "12px",
                  padding: "4px 20px",
                  "&:hover": { background: "transparent" },
                }}
              >
                Organization Admin
              </MenuItem>

              <Divider sx={{ borderColor: COLORS.border, my: 1 }} />

              <MenuItem
                onClick={handleLogOut}
                sx={{
                  color: COLORS.accent,
                  padding: "12px 20px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                <LogoutIcon sx={{ fontSize: "18px" }} />
                Logout
              </MenuItem>
            </Menu>
          </Stack>
        </Toolbar>
      </StyledAppBar>

      {/* Drawer */}
      <StyledDrawer variant="permanent" open={open} customColors={COLORS}>
        <DrawerHeader
          sx={{
            minHeight: "70px",
            borderBottom: `1px solid ${COLORS.border}`,
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            padding: 0,
          }}
        >
          {open && isAuthenticated && (
            <>
              {/* Organization Logo and Name Section */}
              <Box
                sx={{
                  backgroundColor: COLORS.cardBg || "white",
                  padding: "15px",
                  borderRadius: "8px",
                  margin: "10px",
                  textAlign: "center",
                  gap: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  borderBottom: `1px solid ${COLORS.border}`,
                }}
              >
                {organizationDetails?.organization_logo_url && (
                  <Box
                    component="img"
                    src={fixLinodeUrl(organizationDetails?.organization_logo_url)}
                    alt="Org Logo"
                    sx={{
                      background:"white",
                      width: "200px",
                      height: "50px",
                      objectFit: "cover",
                      borderRadius:1,
                    }}
                  />
                )}

                {organizationDetails?.organization_name && (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: COLORS.text,
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {organizationDetails?.organization_name}
                  </Typography>
                )}

                <Tooltip title={`${user?.name || ""}`} placement="right">
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: COLORS.text,
                      maxWidth: "160px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Welcome {userName}
                  </Typography>
                </Tooltip>
              </Box>

              {/* Navigation Title */}
              <Box sx={{ pr: 2, width: "100%" }}>
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: COLORS.accent,
                    textTransform: "uppercase",
                    letterSpacing: "1.5px",
                    mb: 1,
                  }}
                >
                  Navigation
                </Typography>
              </Box>
            </>
          )}
        </DrawerHeader>

        {/* Navigation List */}
        <List sx={{ color: COLORS.text, flex: 1 }}>
          {menuItems.map((item) => (
            <ListItem key={item.key} disablePadding>
              <ListItemButton
                onClick={() => handleListItemClick(item.key)}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                  "&:hover": {
                    background: COLORS.hoverBg,
                    color: COLORS.accent,
                  },
                  color: menudata === item.key && !selectedOrgMaster ? COLORS.accent : COLORS.text,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: "inherit",
                  }}
                >
                  <item.icon sx={{ fontSize: "22px" }} />
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  sx={{
                    opacity: open ? 1 : 0,
                    fontSize: "14px",
                    "& .MuiTypography-root": {
                      fontSize: "14px",
                      fontWeight: menudata === item.key && !selectedOrgMaster ? 600 : 500,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        {/* Bottom Divider */}
        <Divider sx={{ borderColor: COLORS.border }} />

        {/* Bottom Actions */}
        {open && (
          <Box
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Button
              onClick={handleLogOut}
              fullWidth
              sx={{
                color: COLORS.accent,
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: "flex-start",
                textTransform: "none",
                fontSize: "14px",
                padding: "10px 12px",
                borderRadius: "6px",
                border: `1px solid ${COLORS.border}`,
                "&:hover": {
                  background: COLORS.hoverBg,
                  borderColor: COLORS.accent,
                },
              }}
            >
              <LogoutIcon sx={{ fontSize: "18px" }} />
              Logout
            </Button>
          </Box>
        )}
      </StyledDrawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1,
          pt:1,
          minHeight: "100vh",
          background: COLORS.background,
          overflow: "auto",
        }}
      >
        {/* Dashboard */}
        {menudata === "Dashboard" && <OrganizationDashboard />}

        {/* Organization Master Cards Grid */}
        {menudata === "Organization Master" && showOrgMasterCards && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
              gap: 3,
              mt: 2,
            }}
          >
            {organizationMasterOptions.map((option) => (
              <Card
                key={option.key}
                onClick={() => handleOrgMasterCardClick(option.key, option.title)}
                sx={{
                  minWidth: { xs: 260, sm: 300 },
                  borderRadius: "10px",
                  border: `1px solid ${COLORS.border}`,
                  boxShadow: "0 10px 20px rgba(0,0,0,0.08)",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  background: COLORS.cardBg,
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
                  },
                }}
              >
                {/* Image content */}
                <Box p={1.5}>
                  <Box
                    sx={{
                      borderRadius: "8px",
                      bgcolor: COLORS.card_img_bg || "#f5f5f5",
                      overflow: "hidden",
                      height: 180,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={option.image}
                      alt={option.title}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>

                <CardContent>
                  {/* Badges */}
                  <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
                    {option.badge && (
                      <Chip
                        label={option.badge}
                        size="small"
                        sx={{
                          bgcolor: COLORS.button_red_bg,
                          color: COLORS.background,
                          fontWeight: 600,
                          fontSize: "12px",
                        }}
                      />
                    )}

                    {option.tag && (
                      <Chip
                        label={option.tag}
                        size="small"
                        sx={{
                           background:COLORS.card_chip_bg,
                           color:COLORS.card_txt_color,
                          fontSize: "12px",
                        }}
                      />
                    )}
                  </Box>

                  {/* Title */}
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: COLORS.text,
                      mb: 1,
                    }}
                  >
                    {option.title}
                  </Typography>

                  {/* Subtitle */}
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: COLORS.textSecondary,
                      lineHeight: 1.4,
                    }}
                  >
                    {option.subtitle}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}

        {/* Candidate Management Cards Grid */}
        {menudata === "Candidate Management" && showCandidateCards && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
              gap: 3,
              mt: 2,
            }}
          >
            {candidateManagementOptions.map((option) => (
              <Card
                key={option.key}
                onClick={() => handleCandidateCardClick(option.key, option.title)}
                sx={{
                  minWidth: { xs: 260, sm: 300 },
                  borderRadius: "10px",
                  border: `1px solid ${COLORS.border}`,
                  boxShadow: "0 10px 20px rgba(0,0,0,0.08)",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  background: COLORS.cardBg,
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
                  },
                }}
              >
                {/* Image content */}
                <Box p={1.5}>
                  <Box
                    sx={{
                      borderRadius: "8px",
                      bgcolor: COLORS.card_img_bg || "#f5f5f5",
                      overflow: "hidden",
                      height: 180,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={option.image}
                      alt={option.title}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>

                <CardContent>
                  {/* Badges */}
                  <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
                    {option.badge && (
                      <Chip
                        label={option.badge}
                        size="small"
                        sx={{
                          bgcolor: COLORS.button_red_bg,
                          color: COLORS.background,
                          fontWeight: 600,
                          fontSize: "12px",
                        }}
                      />
                    )}

                    {option.tag && (
                      <Chip
                        label={option.tag}
                        size="small"
                        sx={{
                          background:COLORS.card_chip_bg,
                          color:COLORS.card_txt_color,
                          fontSize: "12px",
                        }}
                      />
                    )}
                  </Box>

                  {/* Title */}
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: COLORS.text,
                      mb: 1,
                    }}
                  >
                    {option.title}
                  </Typography>

                  {/* Subtitle */}
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: COLORS.textSecondary,
                      lineHeight: 1.4,
                    }}
                  >
                    {option.subtitle}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}

        {/* Organization Master Sub-pages */}
        {selectedOrgMaster === "Department Management" && <DepartmentManagement />}
        {selectedOrgMaster === "Role Management" && <RoleManagement />}

        {/* Candidate Management Sub-pages */}
        {menudata === "View Candidate" && (
          <ViewCandidate onOpenCandidate={handleOpenCreateNewCandidate} />
        )}
        {menudata === "Candidates Hired" && <CandidatesHiredRejected value="Hired" />}
        {menudata === "Candidates Rejected" && <CandidatesHiredRejected value="Rejected" />}

        {/* Other Pages */}
        {menudata === "User Management" && <UserManagement />}
        {menudata === "Page access rights" && <PageRightsAccess />}
        {menudata === "Create New Job" && <JobDescription />}
        {menudata === "View Existing Jobs" && (
          <JobDescriptionManagementList onOpenJobDescription={handleOpenCreateNewJob} />
        )}
        {menudata === "Schedule Interview" && <ScheduleInterview />}
        {menudata === "List Interview" && <ListInterview />}
        {menudata === "Upcoming Interviews" && <UpcomingInterviews />}
        {menudata === "Completed Interviews" && <CompletedInterviews />}
        {menudata === "Candidate Performance" && <CandidatePerformance />}

        {/* Modal Components */}
        {showCreateNewCandidate && <AddNewCandidate />}
        {showCreateNewJob && <JobDescription />}
      </Box>
    </Box>
  );
};

export default OranizationLandingPage;